import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { WhitePanel } from '../../../components';

import { formatToShow } from '../../../lib/helpers';

export default function TransportationOrder({ order, currency }) {
  const {
    amount,
    itemData: {
      itemData: { from, to, numPax, startDate },
      modelData: { mode, inclusions, vehicleType, departFrom },
    },
  } = order;


  const items = [
    { title: 'Date', value: startDate},
    { title: 'Mode', value: mode },
    { title: 'No. of People', value: numPax },
    { title: 'Vehicle Type', value: vehicleType },
  ];
  
  if (departFrom) items.push({ title: 'Departs From', value: departFrom[from.toLowerCase()] });

  return (
    <div className="cart-item">
      <span className="date">{formatToShow(startDate)}</span>
      <WhitePanel>
        <div className="cart-item-detail">
          <div className="item-details">
            <div className="item-detail-left">
              <h5>
                {from} - {to}
              </h5>
              <div className="service-holder">
                {!isEmpty(inclusions) && <span>Includes: {inclusions.join(' - ')}</span>}
              </div>
              {/* <ul className="detail-list">
                {items.map(({ title, value }) => (
                  <li key={title}>
                    <div className="dt-title">{title}</div>
                    <div className="dt-detail">{value}</div>
                  </li>
                ))}
              </ul> */}
            </div>
            <div className="item-detail-right">
              <p>
                {currency} {amount}
              </p>
            </div>
            <div className="item-detail-left full-flex">
              <ul className="detail-list">
                {items.map(({ title, value }) => (
                  <li key={title}>
                    <div className="dt-title">{title}</div>
                    <div className="dt-detail">{value}</div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </WhitePanel>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Transportation/Common/TransportationOrder.js